import tableRelatedOrganization from './tableRelatedOrganization';
import tableRelatedUsers from './tableRelatedUsers';

export default {
  title: 'Organizations',
  attributeName: 'name',
  getURL: 'userOrganizationList',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: [],
  tableConfig: tableRelatedOrganization
};
